import RequestReceiverSelect from "./requestReceiverSelect.container";

export default RequestReceiverSelect;
